import type { WizardFlowDefinition } from '../flowTypes';
import BookingStartStep from '../../components/booking/BookingStartStep';
import BookingSummaryStep from '../../components/booking/BookingSummaryStep';
import BookingConfirmationStep from '../../components/booking/BookingConfirmationStep';
import ContactInfoStep from '../../components/steps/ContactInfoStep';
import TimeSelectionStep from '../../components/steps/TimeSelectionStep';
import GdprStep from '../../components/shared/GdprStep';
import { requireContactInfo, requireTimeSelection } from '../sharedValidators';

const bookingPhases = [
  { id: 'intro', name: 'Start' },
  { id: 'details', name: 'Oplysninger' },
  { id: 'review', name: 'Gennemse' },
  { id: 'completion', name: 'Afslut' }
] as const;

const bookingFlow: WizardFlowDefinition = {
  id: 'tidsbestilling',
  startStep: 'bk_start',
  phases: bookingPhases,
  steps: {
    bk_start: { id: 'bk_start', name: 'Tidsbestilling', component: BookingStartStep, next: 'gdpr', phase: 'intro' },
    gdpr: { id: 'gdpr', name: 'GDPR', component: GdprStep, next: 'contact_info', phase: 'intro' },
    contact_info: {
      id: 'contact_info',
      name: 'Kontakt',
      component: ContactInfoStep,
      next: 'select_time',
      validate: requireContactInfo,
      phase: 'details'
    },
    select_time: {
      id: 'select_time',
      name: 'Vælg tid',
      component: TimeSelectionStep,
      next: 'bk_summary',
      validate: requireTimeSelection,
      phase: 'details'
    },
    bk_summary: { id: 'bk_summary', name: 'Oversigt', component: BookingSummaryStep, next: 'bk_confirmation', phase: 'review' },
    bk_confirmation: { id: 'bk_confirmation', name: 'Bekræftelse', component: BookingConfirmationStep, phase: 'completion' }
  }
};

export { bookingFlow };
